var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#CDF2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.179 26V23.7841L19.3565 18.9901C19.7969 18.5639 20.1662 18.1804 20.4645 17.8395C20.7675 17.4986 20.9972 17.1648 21.1534 16.8381C21.3097 16.5066 21.3878 16.1491 21.3878 15.7656C21.3878 15.3395 21.2907 14.9725 21.0966 14.6648C20.9025 14.3523 20.6373 14.1132 20.3011 13.9474C19.965 13.777 19.5838 13.6918 19.1577 13.6918C18.7126 13.6918 18.3243 13.7817 17.9929 13.9616C17.6615 14.1416 17.4058 14.3996 17.2259 14.7358C17.0459 15.072 16.956 15.4721 16.956 15.9361H14.0369C14.0369 14.9844 14.2524 14.1581 14.6832 13.4574C15.1141 12.7566 15.7178 12.2145 16.4943 11.831C17.2708 11.4474 18.1657 11.2557 19.179 11.2557C20.2206 11.2557 21.1274 11.4403 21.8991 11.8097C22.6757 12.1742 23.2794 12.6809 23.7102 13.3295C24.1411 13.9782 24.3565 14.7216 24.3565 15.5597C24.3565 16.1089 24.2476 16.651 24.0298 17.1861C23.8168 17.7211 23.4356 18.3153 22.8864 18.9688C22.3371 19.6174 21.563 20.3963 20.5639 21.3054L18.4403 23.3864V23.4858H24.5483V26H14.179Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.87765c07a71b9ff336b1ab733d9dadc2.svg";
export { ForwardRef as ReactComponent };